<template>
    <tr class="table-light">
        <template v-for="(coluna, ic) in colunas">
            <td :key="ic" :class="coluna.align ? 'text-' + coluna.align : ''" v-if="true">
                <a href="#" @click.prevent="addFiltro(coluna, linha[coluna.name])" :style="printableFont" v-if="!printable">
                    {{ formatar(coluna, linha[coluna.name]) }}
                </a>
                <template v-else>
                    {{ formatar(coluna, linha[coluna.name]) }}
                </template>
            </td>
            <td v-if="coluna.percent" :key="'percent-l' + ic" class="text-right small">
                {{ $util.formatMoeda(calc_percent(totalizar (dados, coluna.name, 0), linha[coluna.name])) }}%
            </td>
        </template>
    </tr>
</template>

<script>
import _ from 'lodash';
import * as moment from "moment";

export default {
    props: [ 'linha', 'relatorio', 'printableFont', 'addFiltro', 'dados', 'podebc', 'printable' ],

    computed: { 
        colunas_pivot: function () { 
            return this.$parent.listar({ name: this.relatorio.pivot_col.column_name });
        },

        colunas: function () { 
            return this.relatorio.result.columns; // .filter(coluna => !coluna.hide);
        }
    },
    
    methods: { 
        calc_percent (total, parte) { 
            if ( !total )
                return null;

            return ( parte / total ) * 100;
        },

        formatar(campo, valor) {
            if (!campo.format && campo.type != "value") 
                return valor;

            switch (campo.type) {
                case "time":
                case "timestamp":
                    return valor 
                        ? ( campo.format.substr(0,3) == 'H:i' 
                        ? valor.substr(11,5)
                        : ( this.$util.getFormatDate(valor) + ( campo.format.substr(0,9) == 'd/m/Y H:i' ? ( ' ' + valor.substr(11,5) ) : '' ) ) )
                        : "";

                case "computed":
                case "value":
                    if ( !isNaN(valor) && campo.format == 'min2time' ) { 
                        return moment.utc(valor * 60 * 1000).format("HH:mm:ss");
                    }

                    if ( valor && isNaN(valor) && ( campo.format == 'D' ) ) {
                        return this.$util.getFormatDate(valor);
                    } else if ( valor && isNaN(valor) && ( campo.format == 'DH' ) ) {
                        return this.$util.getFormatDate(valor) + ' ' + valor.slice(11,16);
                    } 

                    if ( isNaN(valor) || isNaN(campo.format) ) { 
                        return valor;
                    }

                    return this.$util.formatNumber(valor, campo.format);

                default:
                return valor;
            }
        },

        totalizar(dados, campo, flat = 0) {
            if (flat) {
                if ( flat == 3 ) { 
                    dados = _.flatMap(dados, (item) => _.values(item));
                    dados = _.flatMap(dados, (item) => _.values(item));
                    dados = _.values(dados).flat();
                } else  if ( flat == 2 ) { 
                    dados = _.flatMap(dados, (item) => _.values(item));
                    dados = _.values(dados).flat();
                } else { 
                    dados = _.flatMap(dados);
                }
            }

            return dados.reduce((total, item) => {
                return total + ( ( isNaN(item[campo]) || !item[campo] ) ? 0 : parseFloat(item[campo]) );
            }, 0);
        },
    }
}
</script>